module.exports = __webpack_public_path__ + "img/20190919155820360截图20190919150325969.12ad74d8.jpg";